import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { Metadata } from 'src/app/models/robot-family-metadata';
import { UNICODE } from '../../constants/general-constants';

@Component({
    selector: 'app-metadata-table-cell',
    templateUrl: './metadata-table-cell.component.html',
    styleUrls: ['./metadata-table-cell.component.css'],
    standalone: false
})
export class MetadataTableCellComponent implements OnInit, AfterViewInit {
  @Input() public tableData: Metadata[];

  @ViewChild(MatTable) public table: MatTable<Metadata>;
  @ViewChild(MatSort) public sort: MatSort;

  public displayedColumns = ['extent_type', 'confidence', 'priority'];
  public dataSource = new MatTableDataSource();

  constructor() {}

  public ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  public ngOnInit() {
    this.dataSource.data = this.tableData;
    this.dataSource.sortingDataAccessor = this.customSortingDataAccessor;
  }

  public customSortingDataAccessor(data: any, sortHeaderId: string): string {
    if (typeof data[sortHeaderId] === 'boolean') {
      return data[sortHeaderId].toString();
    }
    if (typeof data[sortHeaderId] === 'string') {
      return data[sortHeaderId].toLowerCase();
    }
    if (!data[sortHeaderId]) {
      if (this.sort.direction === 'desc') {
        return UNICODE.NULL + UNICODE.NULL + UNICODE.NULL;
      }

      return UNICODE.MAX_CHAR + UNICODE.MAX_CHAR + UNICODE.MAX_CHAR;
    }

    return data[sortHeaderId];
  }
}
